import React, { useState, useEffect } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import './ProductCard.css'

function AnimatedNumber({ value }) {
  const [previousValue, setPreviousValue] = useState(value)
  const [direction, setDirection] = useState(1) 

  useEffect(() => {
    if (value !== previousValue) {
      setDirection(value > previousValue ? 1 : -1)
      setPreviousValue(value)
    }
  }, [value, previousValue])

  const variants = {
    enter: (direction) => ({
      y: direction > 0 ? 25 : -25,
      opacity: 0,
    }),
    center: {
      y: 0,
      opacity: 1,
    },
    exit: (direction) => ({
      y: direction > 0 ? -25 : 25,
      opacity: 0,
    })
  }

  return (
    <div className="quantity-container">
      <AnimatePresence initial={false}>
        <motion.span
          key={value}
          className="quantity"
          custom={direction}
          variants={variants}
          initial="enter"
          animate="center"
          exit="exit"
          transition={{
            type: "spring",
            stiffness: 400,
            damping: 25,
            duration: 0.25
          }}
        >
          {value}
        </motion.span>
      </AnimatePresence>
    </div>
  )
}

export default AnimatedNumber
